module.exports = __webpack_public_path__ + "media/images/socials/instagram-ff4fb0645eb4b73ec62ae08d10e18ed4.png";